import React from 'react';

// Taking Course
import SingleCourse from '../OnlineTraining/DisplayCourseInfo/EachCoursePage.component.jsx';
import CourseHomepage from '../TrainingRoutes/TakeCourse/CourseHomepage.component.jsx';

// Quiz
import QuizComponent from '../TrainingRoutes/Quiz/QuizHomepage.component.jsx';

// Review
import CourseReview from '../TrainingRoutes/ReviewCourse/CourseReview.component.jsx';

// Complete/Incomplete
import CourseComplete from '../TrainingRoutes/FinishedCourse/Completed/QuizCompletePage.component.jsx';
import IncompleteCourse from '../TrainingRoutes/FinishedCourse/Incomplete/QuizIncompletePage.component.jsx';
import TDGCertificateHomepage from '../TrainingRoutes/Certificates/TDGCertificate/TDGCertHomepage.component.jsx';

export const courseRoutes = [
  { path: ':id', element: <SingleCourse /> },
  { path: 'home/:id', element: <CourseHomepage /> },
  { path: 'quiz/:id', element: <QuizComponent /> },
  { path: 'quiz/complete/:id', element: <CourseComplete /> },
  { path: 'tdg-certificate/:id', element: <TDGCertificateHomepage /> },
  { path: 'quiz/incomplete/:id', element: <IncompleteCourse /> },
  { path: 'review/:id', element: <CourseReview /> },
];
